var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "23px",
    viewBox: "0 0 23 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Components/_resources/Icons/32/calendar") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PKD_Klickstrecke-Angebot_020a",
    transform: "translate(-348.000000, -903.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "basisleistungen",
    transform: "translate(318.000000, 462.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "list",
    transform: "translate(1.000000, 56.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "calendar",
    transform: "translate(20.000000, 376.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.7089844,17.5703906 L9.79101562,17.5703906 C9.3515625,17.5703906 9,17.2188281 9,16.779375 C9,16.3399219 9.3515625,15.9440625 9.79101562,15.9440625 L30.7089844,15.9440625 C31.1484375,15.9440625 31.5,16.3399219 31.5,16.779375 C31.5,17.2188281 31.1484375,17.5703906 30.7089844,17.5703906 Z M30.7089844,31.5007031 L9.79101562,31.5007031 C9.3515625,31.5007031 9,31.1491406 9,30.7096875 L9,11.9010937 C9,11.4616406 9.3515625,11.1100781 9.79101562,11.1100781 L30.7089844,11.1100781 C31.1484375,11.1100781 31.5,11.4616406 31.5,11.9010937 L31.5,30.7096875 C31.5,31.1491406 31.1484375,31.5007031 30.7089844,31.5007031 Z M10.6263281,29.8750781 L29.874375,29.8750781 L29.874375,12.6921094 L10.6263281,12.6921094 L10.6263281,29.8750781 Z M25.8314063,14.8014844 C25.3919531,14.8014844 25.0403906,14.405625 25.0403906,13.9661719 L25.0403906,9.79101562 C25.0403906,9.3515625 25.3919531,9 25.8314063,9 C26.2708594,9 26.6224219,9.3515625 26.6224219,9.79101562 L26.6224219,13.9661719 C26.6224219,14.405625 26.2708594,14.8014844 25.8314063,14.8014844 Z M20.25,14.8014844 C19.8105469,14.8014844 19.4589844,14.405625 19.4589844,13.9661719 L19.4589844,9.79101562 C19.4589844,9.3515625 19.8105469,9 20.25,9 C20.6894531,9 21.0410156,9.3515625 21.0410156,9.79101562 L21.0410156,13.9661719 C21.0410156,14.405625 20.6894531,14.8014844 20.25,14.8014844 Z M14.6692969,14.8014844 C14.2298438,14.8014844 13.8782813,14.405625 13.8782813,13.9661719 L13.8782813,9.79101562 C13.8782813,9.3515625 14.2298438,9 14.6692969,9 C15.10875,9 15.5046094,9.3515625 15.5046094,9.79101562 L15.5046094,13.9661719 C15.5046094,14.405625 15.10875,14.8014844 14.6692969,14.8014844 Z",
    id: "Components/_resources/Icons/32/calendar"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.6cb29038256658d1bd7e9907fa5e23de.svg";
export { ForwardRef as ReactComponent };